import status from '@/http/requests/status';

export default {
    fetchPaginated({ commit }, data) {
        return new Promise((resolve, reject) => {
            status.fetchPaginated(data.sortName, data.page, data.itemsPerPage, data.type, data.word)
            .then((response) => {
                const parsedData = response.data.data.getStatusPaginated;

                commit('SET_STATUSES_PAGINATED', parsedData);
                resolve(response);
            })
            .catch((exception) => {
                reject(exception);
            });
        })
    }
}